export default __webpack_public_path__ + "static/heroSectionImg-93d25d500fcf3e224b736b2bdd580d04.webp";